module.exports = __webpack_public_path__ + "static/media/domiart.557e4f50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/domiart.svg
// module id = 1058
// module chunks = 0